import './style.css';
import { startApp } from './app';

const host = document.querySelector<HTMLDivElement>('#app');
if (!host) throw new Error('#app missing');

startApp(host);
